import React from "react";
import {Spinner} from "flowbite-react";

const Loading = () => {
    return (
        <div
            className="text-center bg-slate-300 bg-opacity-50 absolute w-full h-full grid place-items-center rounded-lg">
            <Spinner aria-label="verify email" size="xl" color="success"/>
        </div>
    );
};

export default Loading;